import { render, staticRenderFns } from "./ChatSnapchat.vue?vue&type=template&id=120b7e0c&"
import script from "./ChatSnapchat.vue?vue&type=script&lang=js&"
export * from "./ChatSnapchat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports